<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <section>
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="6" class="padding-ten-tb float-left">
          <h5 class="title__name">Programación Masiva</h5>
        </b-col>
      </b-row>
      <b-row style="max-width: 100%">
        <b-col lg="12">
          <h5 class="text-underline">Instrucciones :</h5>
          <p>
            Para la correcta importacion de los datos realice los siguientes
            pasos: <br />
            1.-Generar el archivo excel que se va importar con el boton "Descargar plantilla" <br />
            2.-Guarde el archivo excel y edite los valores que se ingresaran
            <br />
            3.-Importar el archivo excel editado con el boton "Subir archivo"
            <br />
            4.-Ingresa tu correo (no es obligatorio) 
            <br />
            5.-Haz click en el botón Cargar <br />
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12">
          <div class="vertical-align-bottom">
            <a
              class="btn-orange btn-secondary btn "
              href="/files/plantilla-programacion.xlsx"
              download
              >Descargar plantilla</a
            >
          </div>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col xs="12" sm="12" md="4" lg="4" class="padding-ten-tb float-left">
          <div class="vertical-align-bottom">
            <b-form-file
              accept=".xlsx"
              @change="onChange($event)"
              class="mt-3"
              ref="file-input"
            ></b-form-file>
          </div>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col lg="12" class="text-left">
          <b-button class="btn-orange " @click="uploadFile">
            <font-awesome-icon icon="save" />
            Cargar
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="response.data.length">
        <b-col lg="12">
          <ul
                v-for="(item,index) in response.data"
                :value="item"
                :key="index"
              >
               <li>{{ item.sequence }} - {{ item.message }} </li>
              </ul>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
import { read, utils } from "xlsx";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "ProgramacionMasiva",
  data() {
    return {
      file: "",
      request:  [],
      response:{
        data:[]    
      }
      
    };
  },
  computed: {
    ...mapState("module", ["store", "username"]),
  },
  methods: {
    resetData(){
      if(this.response.data.length){
        this.response={
          data:[]
        }
      }
    },
    async uploadFile() {
     this.resetData();
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await axios.post(
          process.env.VUE_APP_API_PROGRAMACION_BASE,
          this.request,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = {
          variant: "success",
          msg:
            "Se ha registrado exitosamente",
        };
        this.response=response.data;
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.file = null;
        this.clearFiles();
      } catch (e) {
        let values = { variant: "danger", msg: e.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(e);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => {
          this.$store.commit("setShowAlert", false);
          
        }, 6000);
      }
    },
    clearFiles() {
      this.$refs["file-input"].reset();
    },
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      console.log(this.file);
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          console.log(bstr);
          const wb = read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          //console.log(ws);
          /* Convert array of arrays */
          const data = utils.sheet_to_json(ws);
          //console.log(data,'daaa')
          console.log(utils.sheet_to_json(ws, { header: 0 }));
          //const data = utils.sheet_to_json(ws, { header: 1 });

          var result = data.map((item) => ({
            sequence:  item.Orden_Servicio.toString(),
            userTechnician: item.USUARIO_TECNICO.toString(),
            usernameProvider:this.username
          }));
          this.request = result;
        };

        reader.readAsBinaryString(this.file);
      }
    },
  },
};
</script>
